import { useStoreCardView } from "@usher/pe-client-front-end-lib"
import { CardsList } from "./CardsList"
import { PayoutsList } from "./PayoutsList"

const PAGE_SIZE = 5

type Props = {
  isOrders?: boolean
  isCard?: boolean
}

export const TransactionsCardList = ({ isCard = false, isOrders = false }: Props) => {
  const { type, id } = useStoreCardView((state) => state.card)

  const isPayoutType = type === "3" && !isCard

  if (isOrders && !isCard && type !== "3") {
    return null
  }

  if (isPayoutType) {
    return (
      <div>
        return <PayoutsList cardId={id} pageSize={PAGE_SIZE} isOrders={isOrders} />
      </div>
    )
  }

  return <CardsList pageSize={PAGE_SIZE} isOrdersWithPayouts={isOrders && isCard && type === "3"} />
}
